<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div *ngIf="accessLoader" class="loader text-center">
	<img src="../assets/img/cc_loader.gif" />
</div>
<div class="card" *ngIf="UserModuleAccess=='Full' && user_type=='cdm'">
	<div class="card-header bg-primary">
		{{pagetitle}}
	</div>
	<div class="card-body">
		<form class="form-horizontal" [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
			<div class="row mb-3">
				<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<custom-input formControlName="f_name" [id]="'f_name'" [label]="'First Name'"
						[required]="f.f_name.hasValidator(requiredValidator)" [hasError]="showError('f_name')"
						[errors]="f.f_name.errors" [customError]="customError?.f_name"></custom-input>
				</div>
				<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<custom-input formControlName="l_name" [id]="'l_name'" [label]="'Last Name'"
						[required]="f.l_name.hasValidator(requiredValidator)" [hasError]="showError('l_name')"
						[errors]="f.l_name.errors" [customError]="customError?.l_name"></custom-input>
				</div>
			</div>
			<div class="row mb-3">
				<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<phone-email-input formControlName="phone_no" [type]="'phone'" [id]="'phone_no'"
						[label]="'Phone Numbers'" [required]="f.phone_no.hasValidator(requiredValidator)"
						[hasError]="showError('phone_no')" [errors]="f.phone_no.errors"
						[customError]="customError?.phone_no"></phone-email-input>
				</div>
				<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<phone-email-input formControlName="email" [type]="'email'" [id]="'email'" [label]="'Email Ids'"
						[required]="f.email.hasValidator(requiredValidator)" [hasError]="showError('email')"
						[errors]="f.email.errors" [customError]="customError?.email"></phone-email-input>
				</div>
			</div>
			<div class="row mb-3">
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
					<custom-input formControlName="notes" [id]="'notes'" [type]="'textarea'" [label]="'Notes'"
						[required]="f.notes.hasValidator(requiredValidator)" [hasError]="showError('notes')"
						[errors]="f.notes.errors" [customError]="customError?.notes"></custom-input>
				</div>
			</div>
			<div class="row mb-3">
				<div class="col text-center">
					<button type="submit" [disabled]="showLoader || !modform.dirty"
						class="btn btn-sm btn-outline-success">
						<span class="me-1">
							<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
							<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
						</span>
						<span>Save</span>
					</button>
					<a class="btn btn-sm btn-outline-dark ms-1" [routerLink]="['/app/poc']">Cancel</a>
				</div>
			</div>
		</form>
	</div>
</div>
<div *ngIf="UserModuleAccess!='Full' || user_type!='cdm'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>